var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxt-drawer",
        {
          attrs: {
            title: _vm.t("pc_comp_table_custom_drawer_title"),
            visible: _vm.showPanel,
            size: "960px",
            "custom-class": "yxt-table__custom-drawer",
            "before-close": _vm.hidePanel,
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showPanel = $event
            },
          },
        },
        [
          _c("div", { staticClass: "custom-column-box" }, [
            _c(
              "div",
              {
                staticClass: "custom-column-left",
                style: _vm.leftStyle && _vm.leftStyle,
              },
              [
                _c("yxt-scrollbar", { attrs: { "fit-height": true } }, [
                  _c(
                    "div",
                    { staticClass: "custom-column-left-container" },
                    _vm._l(_vm.groupList, function (group, index) {
                      var _obj
                      return _c(
                        "div",
                        {
                          key: index,
                          class: [
                            "group-list",
                            group.NoColumn && "group-no-list",
                          ],
                        },
                        [
                          group.NoColumn
                            ? _c(
                                "div",
                                { staticClass: "group-item" },
                                [
                                  _c(
                                    "yxt-checkbox",
                                    {
                                      attrs: { disabled: group.disable },
                                      on: {
                                        change: function ($event) {
                                          _vm.groupItemChange(group)
                                        },
                                      },
                                      model: {
                                        value: group.checked,
                                        callback: function ($$v) {
                                          _vm.$set(group, "checked", $$v)
                                        },
                                        expression: "group.checked",
                                      },
                                    },
                                    [
                                      _c(
                                        "yxt-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            "open-filter": true,
                                            content: group.name,
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "item-text" },
                                            [_vm._v(_vm._s(group.name))]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  group.customColunmnDesc
                                    ? _c(
                                        "yxt-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark ",
                                            content: group.customColunmnDesc,
                                            placement: "top",
                                            "max-width": 440,
                                          },
                                        },
                                        [
                                          _c("yxt-svg", {
                                            staticClass:
                                              "color-gray-6 hover-primary-6",
                                            staticStyle: { cursor: "pointer" },
                                            style:
                                              ((_obj = {}),
                                              (_obj[
                                                _vm.RTLReplaceStyle(
                                                  "margin-left"
                                                )
                                              ] = "4px"),
                                              (_obj[
                                                _vm.RTLReplaceStyle(
                                                  "margin-right"
                                                )
                                              ] = "4px"),
                                              _obj),
                                            attrs: {
                                              "remote-url": "",
                                              width: "16px",
                                              height: "16px",
                                              "icon-class": "question-cirlce-o",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : group.list && group.list.length
                            ? _c("div", { staticClass: "group-item" }, [
                                _c(
                                  "div",
                                  { staticClass: "group-check-all" },
                                  [
                                    _c(
                                      "yxt-checkbox",
                                      {
                                        attrs: {
                                          indeterminate: group.isIndeterminate,
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.groupChange(group)
                                          },
                                        },
                                        model: {
                                          value: group.checkAll,
                                          callback: function ($$v) {
                                            _vm.$set(group, "checkAll", $$v)
                                          },
                                          expression: "group.checkAll",
                                        },
                                      },
                                      [
                                        _c(
                                          "yxt-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              "open-filter": true,
                                              content: group.groupName,
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group-name-text",
                                              },
                                              [_vm._v(_vm._s(group.groupName))]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "item-list" },
                                  _vm._l(group.list, function (item, index) {
                                    var _obj
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "item" },
                                      [
                                        _c(
                                          "yxt-checkbox",
                                          {
                                            staticClass:
                                              "table_yxt-checkbox__input",
                                            attrs: { disabled: item.disable },
                                            on: {
                                              change: function ($event) {
                                                _vm.groupItemChange(group)
                                              },
                                            },
                                            model: {
                                              value: item.checked,
                                              callback: function ($$v) {
                                                _vm.$set(item, "checked", $$v)
                                              },
                                              expression: "item.checked",
                                            },
                                          },
                                          [
                                            _c(
                                              "yxt-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  "open-filter": true,
                                                  content: item.name,
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "item-text" },
                                                  [_vm._v(_vm._s(item.name))]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        item.customColunmnDesc
                                          ? _c(
                                              "yxt-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark ",
                                                  content:
                                                    item.customColunmnDesc,
                                                  placement: "top",
                                                  "max-width": 440,
                                                },
                                              },
                                              [
                                                _c("yxt-svg", {
                                                  staticClass:
                                                    "color-gray-6 hover-primary-6",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  style:
                                                    ((_obj = {}),
                                                    (_obj[
                                                      _vm.RTLReplaceStyle(
                                                        "margin-left"
                                                      )
                                                    ] = "4px"),
                                                    (_obj[
                                                      _vm.RTLReplaceStyle(
                                                        "margin-right"
                                                      )
                                                    ] = "4px"),
                                                    _obj),
                                                  attrs: {
                                                    "remote-url": "",
                                                    width: "16px",
                                                    height: "16px",
                                                    "icon-class":
                                                      "question-cirlce-o",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "custom-column-right" }, [
              _c(
                "div",
                { staticClass: "choice-title" },
                [
                  _c("span", { staticClass: "has-choice" }, [
                    _vm._v(
                      _vm._s(_vm.t("pc_biz_flow_selected")) +
                        "：" +
                        _vm._s(_vm.checkedNum)
                    ),
                  ]),
                  _c(
                    "yxt-button",
                    {
                      attrs: { type: "text", size: "small" },
                      on: { click: _vm.clearChoice },
                    },
                    [_vm._v(_vm._s(_vm.t("pc_comp_table_custom_clear")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "choice-detail",
                  style: _vm.rightStyle && _vm.rightStyle,
                },
                [
                  _c(
                    "yxt-scrollbar",
                    { attrs: { "fit-height": true } },
                    _vm._l(_vm.groupList, function (group, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "list",
                          attrs: { draggable: !group.disableDrag },
                          on: {
                            dragstart: function ($event) {
                              $event.stopPropagation()
                              return (function (event) {
                                return _vm.handleDragStart(event, group, index)
                              })($event)
                            },
                            dragover: function ($event) {
                              $event.stopPropagation()
                              return (function (event) {
                                return _vm.handleDragOver(
                                  event,
                                  group,
                                  index,
                                  -1
                                )
                              })($event)
                            },
                            dragleave: function ($event) {
                              $event.stopPropagation()
                              return (function (event) {
                                return _vm.handleDragLeave(event, group, index)
                              })($event)
                            },
                            dragend: function ($event) {
                              $event.stopPropagation()
                              return (function (event) {
                                return _vm.handleDragEnd(event, group, index)
                              })($event)
                            },
                            drop: function ($event) {
                              $event.stopPropagation()
                              return (function (event) {
                                return _vm.handleDrop(event, group, index)
                              })($event)
                            },
                          },
                        },
                        [
                          group.NoColumn
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm._showGroup(index),
                                      expression: "_showGroup(index)",
                                    },
                                  ],
                                  class: [
                                    _vm.dragMoveState.gourpIndex === index &&
                                      _vm.dragState.type === "group" &&
                                      "col-drag-over",
                                  ],
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "group-head group-head-no-column",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "group-head-no-column-left",
                                        },
                                        [
                                          _vm.isDragging &&
                                          !group.disableDrag &&
                                          !_vm.dragState.dragging
                                            ? _c(
                                                "yxt-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    "open-filter": true,
                                                    effect: "dark",
                                                    content: _vm.t(
                                                      "pc_comp_table_columnCustomDragTip"
                                                    ),
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "custom-column-icon-drag color-gray-6 hover-primary-6",
                                                      on: {
                                                        mousedown: function (
                                                          event
                                                        ) {
                                                          return _vm.handleCanDragStart(
                                                            event,
                                                            true,
                                                            "group"
                                                          )
                                                        },
                                                        mouseup: function (
                                                          event
                                                        ) {
                                                          return _vm.handleCanDragStart(
                                                            event,
                                                            false,
                                                            "group"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("yxt-svg", {
                                                        attrs: {
                                                          width: "16px",
                                                          height: "16px",
                                                          "icon-class": "sort",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "group-name" },
                                            [
                                              _c(
                                                "yxt-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    "open-filter": true,
                                                    content: group.name,
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "item-text",
                                                    },
                                                    [_vm._v(_vm._s(group.name))]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      !group.disable
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "group-item-close",
                                              on: {
                                                click: function ($event) {
                                                  _vm.delChoiceItem(group, -1)
                                                },
                                              },
                                            },
                                            [
                                              _c("yxt-svg", {
                                                staticClass:
                                                  "color-gray-8 hover-bg-gay-3 hand",
                                                attrs: {
                                                  "icon-class": "common_close",
                                                  width: "22px",
                                                  height: "22px",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  class: [
                                    _vm.dragMoveState.gourpIndex === index &&
                                      _vm.dragState.type === "group" &&
                                      "col-drag-over",
                                  ],
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm._showGroup(index) &&
                                            !group.NoColumn,
                                          expression:
                                            "_showGroup(index) && !group.NoColumn",
                                        },
                                      ],
                                      staticClass: "group-head",
                                    },
                                    [
                                      _vm.isDragging &&
                                      !group.disableDrag &&
                                      !_vm.dragState.dragging
                                        ? _c(
                                            "yxt-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                "open-filter": true,
                                                effect: "dark",
                                                content: _vm.t(
                                                  "pc_comp_table_columnCustomDragTip"
                                                ),
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "custom-column-icon-drag color-gray-6 hover-primary-6",
                                                  on: {
                                                    mousedown: function (
                                                      event
                                                    ) {
                                                      return _vm.handleCanDragStart(
                                                        event,
                                                        true,
                                                        "group"
                                                      )
                                                    },
                                                    mouseup: function (event) {
                                                      return _vm.handleCanDragStart(
                                                        event,
                                                        false,
                                                        "group"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("yxt-svg", {
                                                    attrs: {
                                                      width: "16px",
                                                      height: "16px",
                                                      "icon-class": "sort",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "group-name" },
                                        [
                                          _c(
                                            "yxt-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                "open-filter": true,
                                                content: group.groupName,
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item-text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(group.groupName)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._l(group.list, function (item, itemI) {
                                    return _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: item.checked,
                                            expression: "item.checked",
                                          },
                                        ],
                                        key: itemI,
                                        staticClass: "group-item",
                                        class: [
                                          _vm.dragMoveState.gourpIndex ===
                                            index &&
                                            _vm.dragState.type === "item" &&
                                            _vm.dragMoveState.itemIndex ===
                                              itemI &&
                                            "col-drag-over",
                                        ],
                                        attrs: { draggable: !item.disableDrag },
                                        on: {
                                          dragstart: function ($event) {
                                            $event.stopPropagation()
                                            return (function (event) {
                                              return _vm.handleDragStart(
                                                event,
                                                item,
                                                index,
                                                itemI
                                              )
                                            })($event)
                                          },
                                          dragover: function ($event) {
                                            $event.stopPropagation()
                                            return (function (event) {
                                              return _vm.handleDragOver(
                                                event,
                                                item,
                                                index,
                                                itemI
                                              )
                                            })($event)
                                          },
                                          dragleave: function ($event) {
                                            $event.stopPropagation()
                                            return (function (event) {
                                              return _vm.handleDragLeave(
                                                event,
                                                item,
                                                index
                                              )
                                            })($event)
                                          },
                                          dragend: function ($event) {
                                            $event.stopPropagation()
                                            return (function (event) {
                                              return _vm.handleDragEnd(
                                                event,
                                                item,
                                                index
                                              )
                                            })($event)
                                          },
                                          drop: function ($event) {
                                            $event.stopPropagation()
                                            return (function (event) {
                                              return _vm.handleDrop(
                                                event,
                                                item,
                                                index,
                                                itemI
                                              )
                                            })($event)
                                          },
                                        },
                                      },
                                      [
                                        !item.disableDrag &&
                                        _vm.isDragging &&
                                        !_vm.dragState.dragging &&
                                        !item.disable
                                          ? _c(
                                              "yxt-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  "open-filter": true,
                                                  effect: "dark",
                                                  content: _vm.t(
                                                    "pc_comp_table_columnCustomDragTip"
                                                  ),
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "custom-column-icon-drag color-gray-6 hover-primary-6",
                                                    on: {
                                                      mousedown: function (
                                                        event
                                                      ) {
                                                        return _vm.handleCanDragStart(
                                                          event,
                                                          true,
                                                          "item"
                                                        )
                                                      },
                                                      mouseup: function (
                                                        event
                                                      ) {
                                                        return _vm.handleCanDragStart(
                                                          event,
                                                          false,
                                                          "item"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("yxt-svg", {
                                                      attrs: {
                                                        width: "16px",
                                                        height: "16px",
                                                        "icon-class": "sort",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : !item.disableDrag
                                          ? _c("div", {
                                              staticStyle: { width: "14px" },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "yxt-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              "open-filter": true,
                                              content: item.name,
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "item-text" },
                                              [_vm._v(_vm._s(item.name))]
                                            ),
                                          ]
                                        ),
                                        !item.disable
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "group-item-close",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.delChoiceItem(
                                                      group,
                                                      itemI
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("yxt-svg", {
                                                  staticClass:
                                                    "color-gray-8 hover-bg-gay-3 hand",
                                                  attrs: {
                                                    "icon-class":
                                                      "common_close",
                                                    width: "22px",
                                                    height: "22px",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              ),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "current-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "yxt-checkbox",
                {
                  attrs: { indeterminate: _vm.allIndeterminate },
                  on: { change: _vm.checkoutAllChange },
                  model: {
                    value: _vm.checkAll,
                    callback: function ($$v) {
                      _vm.checkAll = $$v
                    },
                    expression: "checkAll",
                  },
                },
                [_vm._v(_vm._s(_vm.t("pc_comp_table_custom_check_all")))]
              ),
              _c(
                "div",
                [
                  _c(
                    "yxt-button",
                    { attrs: { plain: "" }, on: { click: _vm.hidePanel } },
                    [_vm._v(_vm._s(_vm.t("pc_comp_table_cancel")))]
                  ),
                  _c(
                    "yxt-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.changeCheckedList },
                    },
                    [_vm._v(_vm._s(_vm.t("pc_comp_table_confirm")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }